<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>用户列表</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="昵称" prop="nickName">
                <el-input v-model="formInline.nickName" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="username">
                <el-input v-model="formInline.username" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="注册时间" prop="dayStart">
                <el-date-picker v-model="formInline.dayStart" type="date" placeholder="选择日期" @change="startChange" :picker-options="pickerOptionsStart">
                </el-date-picker>
                -
                <el-date-picker v-model="formInline.dayEnd" type="date" placeholder="选择日期" :picker-options="pickerOptionsEnd" @change="endChange">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="fetchList" v-loading="loading" element-loading-text="拼命加载中">
            <el-table-column prop="userId" label="ID">
            </el-table-column>
            <el-table-column prop="nickName" label="昵称">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="性别">
                <div>
                    <span v-if="row.gender === '1'">男</span>
                    <span v-if="row.gender === '2'">女</span>
                    <span v-if="row.gender === '0' || row.gender === null">暂无</span>
                </div>
            </el-table-column>
            <el-table-column prop="zmPhone" label="手机号">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="是否实名">
                <div>
                    <span v-if="row.isIdentified">实名</span>
                    <span v-else>未实名</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="芝麻信用分值">
                <span>
                        {{ row.zmScore || '暂无'}}
                    </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="是否绑定微信">
                <div>
                    <span v-if="row.wxid">已绑定</span>
                    <span v-else>未绑定</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="客户端类型">
                <div>
                    <span>{{clientTypeMap[row.clientType]}}</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="上次登录时间">
                <span v-if="row.lastLogin">{{ new Date(row.lastLogin).getFullYear()+'-'+(new Date(row.lastLogin).getMonth()+1)+'-'+new Date(row.lastLogin).getDate()+' '+new Date(row.lastLogin).getHours()+':'+new Date(row.lastLogin).getMinutes()+':'+new Date(row.lastLogin).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="注册时间">
                <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                                <el-button @click="handleView($index, row)" type="text" size="small">查看</el-button>
                                <!-- <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button> -->
                                <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
                                <el-button @click="handleStop($index, row)" type="text" size="small" v-if="Role === '1' && !row.isForbidden">禁用</el-button>
                                <el-button @click="handleCancel($index, row)" type="text" size="small" v-if="Role === '1' && row.isForbidden">取消禁用</el-button>
                                                                </span>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>
    </div>
</template>

<script>
    import {
        getUsers,
        patchUsersPsd,
        deleteUser,
        filterUser,
        getUserCount
    } from '../../api/version'

    export default {
        data() {
            return {
                Role: sessionStorage.power,
                clientTypeMap: {
                    alipay: '支付宝小程序',
                    wechat: '微信小程序',
                    h5: 'H5网页APP'
                },
                totalNum: 0,
                currentPage: 1,
                loading: false,
                fetchList: [],
                filter: {},
                formInline: {
                    nickName: '',
                    username: '',
                    dayStart: '',
                    dayEnd: '',
                },
                pickerOptionsStart: {
                    disabledDate(time) {

                    }
                },
                pickerOptionsEnd: {
                    disabledDate(time) {

                    }
                },
            }
        },

        created() {
            this.filter = JSON.stringify({
                "limit": 20,
                "skip": 0,
                "order": "userId desc",
            })
            getUsers(sessionStorage.userId, this.filter).then(res => {
                this.fetchList = res.data
                this.loading = false
            })
            getUserCount(sessionStorage.userId, JSON.stringify({})).then(res => {
                this.totalNum = res.data.count
            })

        },

        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                let filter = JSON.parse(this.filter)
                filter.skip = 20 * (--val)
                getUsers(sessionStorage.userId, JSON.stringify(filter)).then(res => {
                    this.fetchList = res.data
                    this.loading = false
                })
            },
            handleEdit() {
                //编辑
            },
            handleCancel(index, row) {
                //禁用
                this.$confirm('此操作将激活该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    patchUsersPsd(sessionStorage.userId, row.userId, {
                        isForbidden: false
                    }).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功激活',
                                type: 'success'
                            });
                            row.isForbidden = false
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消激活'
                    });
                });
            },
            handleView(index, row) {
                this.$router.push('/userView/' + row.userId)
            },
            handleStop(index, row) {
                //禁用
                this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    patchUsersPsd(sessionStorage.userId, row.userId, {
                        isForbidden: true
                    }).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功禁用',
                                type: 'success'
                            });
                            row.isForbidden = true
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消禁用'
                    });
                });
            },
            handleDelete(index, row) {
                this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    deleteUser(sessionStorage.userId, row.userId).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                            this.fetchList.splice(index, 1)
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            resetForm(formName) {
                this.formInline.dayEnd = ''
                this.$refs[formName].resetFields();
            },
            handleAdd() {
                //添加商品
                this.$router.push('/addProduct')
            },
            Search() {
                //搜索
                let data = JSON.parse(this.filter)
                data.skip = 0
                delete data.nickName
                delete data.username
                this.formInline.nickName ? data.nickName = {
                    'like': '%25' + this.formInline.nickName + '%25'
                } : ''
                this.formInline.username ? data.username = {
                    'like': '%25' + this.formInline.username + '%25'
                } : ''
                if (this.formInline.dayStart && !this.dayEnd) {
                    data.created = {
                        gt: this.formInline.dayStart
                    }
                } else if (!this.formInline.dayStart && this.formInline.dayEnd) {
                    data.created = {
                        lt: this.formInline.dayStart
                    }
                } else if (this.formInline.dayStart && this.formInline.dayEnd) {
                    data.created = {
                        between: [this.formInline.dayStart, this.formInline.dayEnd]
                    }
                }
                console.log(data)
                let search = {
                    'where': data
                }
                this.filter = JSON.stringify(data)
                console.log(JSON.stringify(search))
                filterUser(sessionStorage.userId, JSON.stringify(search)).then(res => {
                    this.fetchList = res.data
                }, err => {
                    console.log(err)
                })

                getUserCount(sessionStorage.userId, JSON.stringify(data)).then(res => {
                    this.totalNum = res.data.count
                })
            },
            startChange(val) {
                console.log(val)
                this.pickerOptionsEnd = {
                    disabledDate(time) {
                        return time.getTime() < new Date(val).getTime();
                    }
                }
            },
            endChange(val) {
                console.log(val)
                this.pickerOptionsStart = {
                    disabledDate(time) {
                        return time.getTime() > new Date(val).getTime();
                    }
                }
            }

        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// UserList.vue?21a1b072